import React from 'react'
import ThumbWrapper from './product-list-thumbnail-wrapper'
import ImageStore from '../../../stores/image-store'
import BatchCheckbox from '../../app-templates/ope-checkbox'
import SelectorActions from '../../../actions/selector-actions'
import createReactClass from 'create-react-class'


var ProductListItemThumbnail = createReactClass({
	previousImageSource: null,
	imageFile: null,
    mounted: false,

	getInitialState: function() {
		return {
			imageSource: null,
			productAspect: 1.0,
			imageAspect: 1.0,
			originalImageWidth: null,
			originalImageHeight: null
		}
	},

	componentWillReceiveProps: function() {
		var imageFilter = this.props.item.options.imageFilter;
		if(JSON.stringify(imageFilter) !== this.previousImageSource) {
			this._getImageSource();
		}
	},

	_batchCheckboxCallback: function(event) {
		var target = event.target;
		SelectorActions.toggleItemBatchState(this.props.item, target.checked);
	},

	_getImageSource: function() {
		var instance = this,
			item = instance.props.item,
			imageFilters = instance.props.item.getImageFilters();

		this.imageFile = ImageStore.getImageById(item.imageId);

		this.imageFile.getSrcWithFilter(300, imageFilters).then (
			function (src) {
				if (instance.mounted) {
					instance.setState({imageSource: src} );
					instance.previousImageSource = JSON.stringify(instance.props.item.options.imageFilter);
				}
			})['catch'](function (err) {
				displayError(err.message, {imageId: instance.props.item.getImageId(), error: err});
		});
	},

	render: function() {
		var item = this.props.item,
			options = item.options,
			productIconClass = " ope-product-icon--" + Math.floor(options.productHeight) + "x" + Math.floor(options.productWidth),
			productClass = "ope-product-list__item__product-icon__image ",
			productAspect = parseInt(item.options.productWidth) / parseInt(item.options.productHeight),
			imageAspect = 1.0,
			thumbWidth = 0, thumbHeight = 0;

		if(this.imageFile) {
			imageAspect = this.imageFile.getWidth() / this.imageFile.getHeight();
		}

		if(this.props.expanded) productIconClass += productIconClass + "--expanded";
		productClass += productIconClass;

		var className = this.props.className;
		if (this.props.visible === false) {
			className += " ope-invisible";
		}

		return (

			<div className={className}>
				<ThumbWrapper item={this.props.item} imageSource={this.state.imageSource} image={this.imageFile} imageAspect={imageAspect} productAspect={productAspect} removeHandler={this.props.removeHandler} editHandler={this.props.editCallback} />

				{this.props.batchExpanded ?
					<BatchCheckbox checkboxClassName="ope-checkbox ope-product-list__item__checkbox ope-checkbox--thumbnail" isChecked={this.props.inBatch}
						callback={this._batchCheckboxCallback} checkboxId={'ope-checkbox-' + this.props.item.getId() }/>
					: null }
			</div>
		);
	},

    componentDidMount: function () {
        this.mounted = true;
    },

    componentWillUnmount: function() {
        this.mounted = false;
    }
});

export default ProductListItemThumbnail;
